class upsellItem extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('.button--add-upsell')
        this.button.addEventListener('click', this.addToCart.bind(this));

        this.querySelector('.quantity__input').addEventListener('change', this.handleQtyChange.bind(this));

        this.querySelectorAll('.upsell-item-content .select select').forEach(select => {
            select.addEventListener('change', this.selectChange.bind(this));
        });

        if (this.querySelectorAll('.upsell-item-content .select select') != null) {
            this.selectChange.bind(this)
        }
    }

    addToCart(event) {
        event.preventDefault();

        this.button.classList.add('loading')
        this.button.querySelector('.loading__spinner').classList.remove('hidden')
        this.classList.add('loading-state')
        const id = Number(this.querySelector('[name="id"]').value)
        const qty = Number(this.querySelector('[name="quantity"]').value)

        let formData = {
            'items': [{
             'id': id,
             'quantity': qty
            }]
        };

        if ( this.button.classList.contains('clear-button') ) {
            const updates = { [id]: 0 };

            this.updateCart(updates)
        } else {
                    
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            }).then(data => {
                this.callbackApi(data)
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

    }

    selectChange() {
        const selectedIndex = this.querySelector('.upsell-item-content .select select').selectedIndex;
        const selectedOpt = this.querySelector('.upsell-item-content .select select').options[selectedIndex].value
        const variantsData = JSON.parse(this.querySelector('.variants-data').textContent)
        const priceEl = this.querySelector('.price')
        const variant = variantsData.find(v => v.id == Number(selectedOpt))
        const savedPriceContainer = this.querySelector('.saved-price-el')
        const savedPrice = this.querySelectorAll('.saved-price')

        if (variant) {

            if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
                priceEl.classList.add('price--on-sale')
                priceEl.querySelector('.price__sale s.price-item--regular').textContent = this.dataset.currencySymbol + this.moneyFormatter(variant.compare_at_price) + ' ' + window.Shopify.currency.active
                priceEl.querySelector('.price__sale .price-item--last').textContent = this.dataset.currencySymbol + this.moneyFormatter(variant.price) + ' ' + window.Shopify.currency.active
            } else {
                priceEl.classList.remove('price--on-sale')
                priceEl.querySelector('.price__regular .price-item--regular').textContent = this.dataset.currencySymbol + this.moneyFormatter(variant.price) + ' ' + window.Shopify.currency.active
            }

            if ( savedPriceContainer && savedPrice && variant.compare_at_price && variant.compare_at_price > variant.price ) {
                savedPriceContainer?.removeAttribute('hidden')
                savedPrice.forEach(s=> {
                    s.textContent = this.dataset.currencySymbol + this.moneyFormatter(variant.compare_at_price - variant.price) 
                })
            } else {
                savedPriceContainer?.setAttribute('hidden','')
            }
        }

        if (!variant.available) {
            this.querySelector('.button--add-upsell').setAttribute('hidden','')
            this.querySelector('.button--add-upsell span').textContent = window.variantStrings.soldOut
        } else {
            this.querySelector('.button--add-upsell').removeAttribute('hidden','')
            this.querySelector('.button--add-upsell span').textContent = this.querySelector('.button--add-upsell').dataset.addText
        }
    }
    updateItem() {
        var url = `${this.dataset.url}?sections=${this.dataset.sectionId}`
        const blockId = this.dataset.blockId

        if (document.querySelector('.shipping-msg-bar') != null) {
            url += `,${this.dataset.sectionId + ',' + document.querySelector('.shipping-msg-bar').dataset.sectionId}`
        }

        fetch(url)
        .then(response => response.text())
        .then(responseText => {
            const parsedState = JSON.parse(responseText);
            const qtysFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`[data-block-id="${blockId}"] .quantity__input`).value; // Returns a NodeList
            };

            this.querySelector('.quantity__input').value = qtysFetch();

            const clearFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`[data-block-id="${blockId}"] .clear-button`) != null ? doc.querySelector(`[data-block-id="${blockId}"] .clear-button`).innerHTML : null;
            };

            if (clearFetch() != null) {
                this.querySelector('.button--add-upsell').classList.add('clear-button')
                this.querySelector('.button--add-upsell span').textContent = this.querySelector('.button--add-upsell').dataset.clearText
            } else {
                this.querySelector('.button--add-upsell').classList.remove('clear-button')
                this.querySelector('.button--add-upsell span').textContent = this.querySelector('.button--add-upsell').dataset.addText
            }

            const summaryFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`.subtotal-summary`).innerHTML; // Returns a NodeList
            };
            
            const checkoutBtnFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`.checkout--button`); // Returns a NodeList
            };

            const moreMsgFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`.more-message`); // Returns a NodeList
            };

            const checkoutNoteFetch = () => {
                const doc = new DOMParser().parseFromString(parsedState[this.dataset.sectionId], 'text/html');
                return doc.querySelector(`.checkout-note`); // Returns a NodeList
            };

            var shipMsgSource = null
            const shipMsgDestination = document.querySelector('.shipping-msg-bar');

            if (shipMsgDestination) {
                shipMsgSource = new DOMParser().parseFromString(parsedState[document.querySelector('.shipping-msg-bar').dataset.sectionId], 'text/html');
                shipMsgSource = shipMsgSource.querySelector('.shipping-msg-bar').innerHTML; // Returns a NodeList
            }

            if (shipMsgSource && shipMsgDestination) {
                shipMsgDestination.innerHTML = shipMsgSource
            }

            if (document.querySelector('.subtotal-summary')) {
                document.querySelector('.subtotal-summary').innerHTML = summaryFetch();
            }

            if (document.querySelector('.more-message')) {
                document.querySelector('.more-message').replaceWith(moreMsgFetch());
            }

            if (document.querySelector('.checkout-note')) {
                document.querySelector('.checkout-note').replaceWith(checkoutNoteFetch());
            }

            if (document.querySelector('.checkout--button') && !checkoutBtnFetch().classList.contains('disabled-checkout')) {
                document.querySelector('.checkout--button').classList.remove('disabled-checkout')
            } else {
                document.querySelector('.checkout--button').classList.add('disabled-checkout')
            }

            this.classList.remove('loading-state')
            this.button.classList.remove('loading')
            this.button.querySelector('.loading__spinner').classList.add('hidden')

            document.querySelectorAll('.warning-checkout').forEach(warning => {
                warning.setAttribute('hidden', '');
            })
        })
    }

    updateLiveRegions(message) {
        const lineItemError = this.querySelector('.cart-item__error');
        lineItemError.setAttribute('aria-hidden', false);

        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    
        setTimeout(() => {
            lineItemError.setAttribute('aria-hidden', true);
        }, 1500);
    }

    updateCart(updates) {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        }).then((data) => {
            this.callbackApi(data)
        });
    }

    callbackApi(data) {
        if (data.message) {
            this.updateLiveRegions(data.message)
        }
        this.updateItem()
        document.querySelector('cart-total')?.refreshDom()
    }

    handleQtyChange() {
        const id = Number(this.querySelector('[name="id"]').value)
        const qty = Number(this.querySelector('[name="quantity"]').value)

        if (this.button.classList.contains('clear-button')) {
            this.classList.add('loading-state')

            const updates = { [id]: qty };
            this.updateCart(updates)
        }
    }
    moneyFormatter(number) {
        let formattedNumber = (number / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formattedNumber;
    }
}
customElements.define('upsell-item', upsellItem);

document.querySelector('.checkout--button')?.addEventListener('click', function(evt) {
    evt.preventDefault()

        const warningMsg = document.querySelector(`.warning-checkout[data-id="${this.id}"]`)
  
        if (this.classList.contains('disabled-checkout')) {
            evt.preventDefault();
          warningMsg.removeAttribute('hidden');
        } else {
            let checkoutUrl = '/checkout';

            if (this.dataset.redirect != undefined) {
                checkoutUrl = this.dataset.redirect;
            }

            window.location = checkoutUrl;
        }
})

document.querySelectorAll('.no-thanks-link a').forEach(link => {
    link.addEventListener('click', function(evt) {
        const warningMsg = document.querySelector('.warning-checkout[data-id="richtext"]')
        const moreMsg = document.querySelectorAll('.more-message')
        const checkoutNote = document.querySelectorAll('.checkout-note')
        
        evt.preventDefault()
        evt.stopPropagation()
        const _this = this

        fetch('/cart.js').then(response => {
            return response.json();
        })
        .then(cartData => { 
            if (cartData.total_price < window.cartLimit) {
                warningMsg.removeAttribute('hidden');

                moreMsg.forEach(more => {
                    more.removeAttribute('hidden');
                })
                
                checkoutNote.forEach(more => {
                    more.setAttribute('hidden','');
                })
            } else {
                warningMsg.setAttribute('hidden','');

                moreMsg.forEach(more => {
                    more.setAttribute('hidden','');
                })
 
                checkoutNote.forEach(more => {
                    more.setAttribute('hidden','');
                })
                window.location = _this.href;
            }
        })
        .catch(error => {
            console.error('Error fetching shopping cart data:', error);
        });
    })
})